export default {
  'transactionReporting.dropdownLabel': 'saved report criteria',
  'transactionReporting.createNew': 'Create New Criteria',
  'transactionReporting.title': 'Generate report',
  'transactionReporting.description':
    'Select a saved report criteria or create a new criteria to begin.',
  'transactionReporting.saveLabel': 'Save this report criteria',
  'transactionReporting.saveAsPlaceholder': 'Report name',
  'transactionReporting.refineText': 'Edit',
  'transactionReporting.headerTitle': 'Report Criteria'
};
